import type { Sys } from 'contentful';
import type { SerializableRecord } from '../model';
import { isSerializableRecord } from '~~/lib/ContentfulTransformerService/helper/isSerializableRecord';

export function transformContentfulSys(
  sys: unknown
): SerializableRecord | undefined {
  if (!isSerializableRecord(sys)) {
    return;
  }

  const typedSys = sys as unknown as Sys;
  const contentTypeSys = typedSys.contentType?.sys;

  return {
    id: sys.id,
    type: sys.type,
    locale: sys.locale,
    updatedAt: sys.updatedAt,
    // urn and linkType are required by normalizeHideableEntry to extract Entra
    // group IDs from allowedBaslerIdGroups entries on the client side.
    ...(sys.urn !== undefined && { urn: sys.urn }),
    ...(sys.linkType !== undefined && { linkType: sys.linkType }),
    contentType:
      contentTypeSys != null
        ? {
            sys: {
              id: contentTypeSys.id,
              type: contentTypeSys.type,
              linkType: contentTypeSys.linkType
            }
          }
        : undefined
  };
}
